import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { Button, Input, Select, Spin, Switch } from "antd";
import { states } from "../../../services/states";
import { InputTel, ViewInput } from "../../../GlobalStyles";

export default function NewEditFranqueado() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [email, setEmail] = useState("");
  const [photo, setPhoto] = useState("");
  const [category, setCategory] = useState("franqueado");
  const [sector1_id, setSector1_id] = useState("");
  const [sector2_id, setSector2_id] = useState("");
  const [sector3_id, setSector3_id] = useState("");
  const [sector4_id, setSector4_id] = useState("");
  const [sector5_id, setSector5_id] = useState("");
  const [services, setServices] = useState([]);
  const [servicesAll, setServicesAll] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [password, setPassword] = useState("");
  const [course, setCourse] = useState(false);
  const [courses, setCourses] = useState([]);
  const [coursesAll, setCoursesAll] = useState([]);
  const [resale, setResale] = useState(false);
  const [signature, setSignature] = useState(false);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");

  useEffect(() => {
    setLoading(true);
    listServices();
    getFranqueado();
    listTecnicos();
    listCourses();
  }, []);

  async function listServices() {
    await api
      .get(`/services?all=true`)
      .then((response) => {
        response.data.map((item) => {
          item.label =
            item.name +
            " - " +
            item.value.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
          item.value = item.id;
        });
        setServicesAll(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function listCourses() {
    await api
      .get(`/courses`)
      .then((response) => {
        response.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        setCoursesAll(response.data.filter((item) => item.id));
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function listTecnicos() {
    setLoading(true);
    await api
      .get(`/collaborators?all=true`)
      .then((response) => {
        let tecnicos = response.data.collaborators;
        tecnicos.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        setTecnicos(tecnicos);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function getFranqueado() {
    setLoading(true);
    if (id != "new") {
      await api
        .get(`/user/${id}`)
        .then((response) => {
          const item = response.data;
          setName(item.name);
          setEmail(item.email);
          setPhoto({ photo_url: item.photo_url });
          setPhone_number(item.phone_number);
          setCategory(item.category);
          setCity(item.city);
          if (item.state) {
            setCities(
              states.filter((item) => {
                return item.state == item.state;
              })[0].cidades,
            );
          }
          setState(item.state);
          setSector1_id(item.sector1_id);
          setSector2_id(item.sector2_id);
          setSector3_id(item.sector3_id);
          setSector4_id(item.sector4_id);
          setSector5_id(item.sector5_id);
          setPassword("");
          setCourse(item.course);
          setResale(item.resale);
          let servicesArray = [];
          item.services.split(";").map((item) => {
            if (item) {
              servicesArray.push(item);
            }
          });
          setServices(servicesArray);
          let coursesArray = [];
          item.courses.split(";").map((item) => {
            if (item) {
              coursesArray.push(item);
            }
          });
          setCourses(coursesArray);
          setSignature(item.signature);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
    setLoading(false);
  }

  async function createAndEditTecnico() {
    let servicesString = "";
    services.map((item) => {
      servicesString += `${item};`;
    });
    let coursesString = "";
    courses.map((item) => {
      coursesString += `${item};`;
    });
    if (id != "new") {
      if (!name || !email || !phone_number) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("phone_number", phone_number);
        data.append("password", password);
        data.append("course", course);
        data.append("courses", coursesString);
        data.append("resale", resale);
        data.append("signature", signature);
        data.append("city", city);
        data.append("state", state);
        data.append("category", category);
        data.append("sector1_id", sector1_id);
        data.append("sector2_id", sector2_id);
        data.append("sector3_id", sector3_id);
        data.append("sector4_id", sector4_id);
        data.append("sector5_id", sector5_id);
        data.append("services", servicesString);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .put(`/user/${id}`, data)
          .then(async (ok) => {
            toast.success(`Franqueado editado com sucesso`);
            navigate(-1);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    } else {
      if (!name || !email || !password || !phone_number) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("phone_number", phone_number);
        data.append("password", password);
        data.append("courses", coursesString);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        data.append("course", course);
        data.append("city", city);
        data.append("state", state);
        data.append("category", category);
        data.append("sector1_id", sector1_id);
        data.append("sector2_id", sector2_id);
        data.append("sector3_id", sector3_id);
        data.append("sector4_id", sector4_id);
        data.append("sector5_id", sector5_id);
        data.append("signature", signature);
        data.append("services", servicesString);
        data.append("resale", resale);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .post(`/user`, data)
          .then(async (ok) => {
            toast.success(`Franqueado criado com sucesso`);
            navigate(-1);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
  }

  return (
    <Container>
      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          <h1>{id != "new" ? "Editar Franqueado" : "Novo Franqueado"}</h1>
          <ViewInput className="input">
            <p>Nome</p>
            <Input
              value={name}
              color="#888"
              placeholder={"João"}
              onChange={(text) => {
                setName(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input">
            <p>Email</p>
            <Input
              value={email}
              placeholder={"usuario@gmail.com"}
              onChange={(text) => {
                setEmail(text.target.value);
              }}
            />
          </ViewInput>

          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Estado</p>
            <Select
              value={state}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setState(value);
                setCities(
                  states.filter((item) => {
                    return item.sigla == value;
                  })[0].cidades,
                );
              }}
            >
              <Select.Option value={""}>Selecione seu estado</Select.Option>
              {states.map((item) => {
                return (
                  <Select.Option value={item.sigla}>{item.nome}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>

          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Cidade</p>
            <Select
              disabled={state == ""}
              value={city}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setCity(value);
              }}
            >
              <Select.Option value={""}>Seleciona sua cidade</Select.Option>
              {cities.map((item) => {
                return <Select.Option value={item}>{item}</Select.Option>;
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Telefone</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              noSpaceBetweenChars={true}
              value={phone_number}
              placeholder={"telefone"}
              style={{}}
              onChange={(text) => {
                setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
              }}
            />
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Tipo do Usuário</p>
            <Select
              value={category}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setCategory(value);
              }}
            >
              <Select.Option value={"franqueado"} label={"Franqueado"}>
                {"Franqueado"}
              </Select.Option>
              <Select.Option value={"terceirize"} label={"Terceirize"}>
                {"Terceirize"}
              </Select.Option>
            </Select>
          </ViewInput>
          <ViewInput>
            <p style={{ marginTop: 10 }}>
              Serviços{" "}
              <span style={{ fontSize: 13 }}>
                (caso n selecione nenhum, aparecerá todos)
              </span>
            </p>
            <Select
              placeholder="selecione serviços para esse franqueado"
              value={services}
              mode="multiple"
              optionFilterProp="label"
              options={servicesAll}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setServices(value);
              }}
            />
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>
                (Serviços de segurança do Trabalho)
              </span>
            </p>
            <Select
              value={sector1_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector1_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Serviços de segurança do Trabalho" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>
                (Revenda de treinamentos online)
              </span>
            </p>
            <Select
              value={sector2_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector2_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Revenda de treinamentos online" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>
                (Serviços Medicina ocupacional)
              </span>
            </p>
            <Select
              value={sector3_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector3_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Serviços Medicina ocupacional" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico <span style={{ fontSize: 13 }}>(Credenciamento SST)</span>
            </p>
            <Select
              value={sector4_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector4_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Credenciamento SST" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>(Assinatura Documentos SST)</span>
            </p>
            <Select
              value={sector5_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector5_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Assinatura Documentos SST" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>{id ? "Nova Senha" : "Senha"}</p>
            <Input
              value={password}
              placeholder={"****"}
              onChange={(text) => {
                setPassword(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput
            style={{
              justifyContent: "flex-start",
              width: 90,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p style={{ marginTop: 10 }}>Revenda</p>
            <Switch
              value={resale}
              style={{
                width: 30,
              }}
              onChange={(value) => {
                setResale(value);
                if (value) {
                  setSignature(false);
                }
              }}
            />
          </ViewInput>
          <ViewInput
            style={{
              justifyContent: "flex-start",
              width: 120,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p style={{ marginTop: 10 }}>Assinatura SST</p>
            <Switch
              value={signature}
              style={{
                width: 30,
              }}
              onChange={(value) => {
                setSignature(value);
                if (value) {
                  setResale(false);
                }
              }}
            />
          </ViewInput>
          <ViewInput
            style={{
              justifyContent: "flex-start",
              width: 200,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p style={{ marginTop: 10 }}>Área do conhecimento</p>
            <Switch
              value={course}
              style={{
                width: 30,
              }}
              onChange={(value) => {
                setCourse(value);
              }}
            />
          </ViewInput>
          {course && (
            <ViewInput>
              <p style={{ marginTop: 20 }}>
                Cursos{" "}
                <span style={{ fontSize: 13 }}>
                  (caso n selecione nenhum, aparecerá todos)
                </span>
              </p>
              <Select
                placeholder="selecione modulos para esse franqueado"
                value={courses}
                mode="multiple"
                optionFilterProp="label"
                options={coursesAll}
                style={{
                  width: "100%",
                  textAlign: "left",
                }}
                onChange={(value) => {
                  setCourses(value);
                }}
              />
            </ViewInput>
          )}

          <Button
            style={{
              marginTop: 25,
              maxWidth: 390,
              width: "100%",
            }}
            type="primary"
            onClick={() => {
              createAndEditTecnico();
            }}
          >
            Salvar
          </Button>
        </>
      )}
    </Container>
  );
}
